import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import { Button, FormHelperText, TextField } from '@mui/material'
import { saveOrUpdateDataById } from '../apis/generalApis'
import Swal from 'sweetalert2'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const DirectDepositModal = ({
  handleDirectDepositModal,
  directDepositModalOpen = false,
}) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [directDepositDetails, setDirectDepositDetails] = React.useState({
    user_id: user?.id,
    bank_account: '',
    bank_account_confirmation: '',
    bank_routing: '',
    bank_routing_confirmation: '',
  })

  const handleChange = (e) => {
    setDirectDepositDetails((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    let body = { ...directDepositDetails }
    let result = await saveOrUpdateDataById('add-bank-details', body)
    if (result?.success === true && result?.data) {
      handleDirectDepositModal(false)
      Swal.fire({
        icon: 'success',
        title: 'Informtion added successfully!',
        timer: 300,
        confirmButtonColor: '#2597F6',
      })
    }
  }

  return (
    <>
      <Modal
        open={directDepositModalOpen}
        onClose={() => handleDirectDepositModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-width">
          <form onSubmit={handleSubmit}>
            <div>
              <h3 className="fs-24 mb-3 fw-bold">Direct Deposit</h3>
              <div>
                <FormHelperText
                  id="input-label"
                  className="mt-4"
                  margin="dense"
                >
                  Bank Account Number
                </FormHelperText>
                {/* <CustomInput
                margin="dense"
                placeholder="################"
                fullWidth={true}
                type="text"
              /> */}
                <TextField
                  type="number"
                  name="bank_account"
                  required
                  margin="dense"
                  placeholder="################"
                  fullWidth={true}
                  value={directDepositDetails.bank_account}
                  onChange={handleChange}
                />
              </div>
              <div>
                <FormHelperText
                  id="input-label"
                  className="mt-3"
                  margin="dense"
                >
                  Confirm Bank Account Number
                </FormHelperText>
                {/* <CustomInput
                margin="dense"
                placeholder="################"
                fullWidth={true}
                type="text"
              /> */}
                <TextField
                  type="number"
                  name="bank_account_confirmation"
                  required
                  margin="dense"
                  placeholder="################"
                  fullWidth={true}
                  value={directDepositDetails.bank_account_confirmation}
                  onChange={handleChange}
                />
              </div>
              <div>
                <FormHelperText
                  id="input-label"
                  className="mt-3"
                  margin="dense"
                >
                  Bank Routing Number
                </FormHelperText>
                {/* <CustomInput
                margin="dense"
                placeholder="################"
                fullWidth={true}
                type="text"
              /> */}
                <TextField
                  type="number"
                  name="bank_routing"
                  required
                  margin="dense"
                  placeholder="################"
                  fullWidth={true}
                  value={directDepositDetails.bank_routing}
                  onChange={handleChange}
                />
              </div>
              <div>
                <FormHelperText
                  id="input-label"
                  className="mt-3"
                  margin="dense"
                >
                  Confirm Bank Routing Account Number
                </FormHelperText>
                {/* <CustomInput
                margin="dense"
                placeholder="################"
                fullWidth={true}
                type="text"
              /> */}
                <TextField
                  type="number"
                  name="bank_routing_confirmation"
                  required
                  margin="dense"
                  placeholder="################"
                  fullWidth={true}
                  value={directDepositDetails.bank_routing_confirmation}
                  onChange={handleChange}
                />
              </div>
              <Button
                fullWidth
                id="btn-primary-no-shadow"
                type="submit"
                className="pointer mt-3"
              >
                Save
              </Button>
              {/* <div className="mt-5">
              <CustomButton title={'Save'} fullWidth={true} />
            </div> */}
            </div>
          </form>
        </Box>
      </Modal>
    </>
  )
}

export default DirectDepositModal
